<template>
  <div class="kids-wishes-layout layers">
    <div class="scroller" ref="scroller">
      <div class="long-content" ref="content">

        <div class="top-taller"></div>

        <div class="single-col">
          <div class="single-row make-a-wish">
            <span v-if="SC.U === CHI">Make-A-Wish Hong Kong</span>
            <span v-if="SC.U === ENG">Make-A-Wish Hong Kong</span>
          </div>
          <div class="single-row wish-children">

            <span v-if="SC.U === CHI">願望成真基金</span>
            <span v-if="SC.U === ENG">Wish Children</span>

          </div>

          <!-- <div class="gallery">

            <div class="photo-set" :key="iPS" v-for="(ps, iPS) in photoSet">
              <div class="ps-photo">
                <img :src="ps.photo">
              </div>
              <div class="ps-title">
                {{ ps[SC.U].title }}
              </div>
              <div class="ps-desc">
                {{ ps[SC.U].desc }}
              </div>
              <div class="ps-wish">
                {{ ps[SC.U].wish }}
              </div>
            </div>

          </div> -->

          <div class="sigle-row maw-desc-row">
            <div class="maw-desc">
              <span v-if="SC.U === CHI">
              感謝您的支持! 您的善心讓更多願望童實現跟創造更多改寫生命的願望，點亮更多璀璨奇蹟。願望成真基金為願望童所帶來的關愛與希望，願望成真的體驗能蛻變生命，好比天上閃爍璀璨的耀目繁星，引領他們奮勇向前，永不言棄。
              </span>
              <span v-if="SC.U === ENG">
              Thank you for your support! Your kindness have illuminated lives and granted life-changing wishes to children in need. A wish-come-true experience transforms lives. The love, kindness and hope the Wish Children received from Make-A-Wish Hong Kong resembles such powerful radiance, as if it is emanated from the stars in the sky.
              </span>
            </div>
          </div>
        </div>

        <div class="">
        </div>

        <div class="ribbon-row">
          <Ribbon :items="kidsItems" @choose="(data) => { iK = data.iK }" />
        </div>

        <div class="cards-row">
          <Cards :items="kidsItems" ref="deck" :nK="iK" />
        </div>

        <div class="link-row">
          <a class="maw-link" target="_blank" href="http://makeawish.org.hk/">Make-A-Wish Hong Kong</a>
        </div> <!-- -->

        <div class="bottom-taller"></div>
        <!-- <div class="taller"></div>
        <div class="taller"></div> -->
      </div>
    </div>
    <FloatMenu class="float-menu" @diamond="() => { fsMenu = !fsMenu }" />
    <FullMenu class="full-menu" v-show="fsMenu" @close="() => { fsMenu = false }" @lang="() => { Text.toggle() }" />
  </div>
</template>

<script>
import FloatMenu from '@/components/DOM/FloatMenu/FloatMenu.vue'
import FullMenu from '@/components/DOM/FullMenu/FullMenu.vue'
import * as Text from '@/components/DOM/Text/Text.js'

import Ribbon from './Ribbon.vue'
import Cards from './Cards/Cards.vue'

import * as ScrollMonitor from '@/components/Parts/ScrollMonitor/ScrollMonitor.js'

// import Instruction from './Instruction.vue'

export default {
  components: {
    FloatMenu,
    FullMenu,
    Ribbon,
    Cards
    // Instruction
  },
  data () {
    let kidsItems = [
      {
        id: 4,
        i1: require('./Items3/04.png'),
        i2: require('./Items3/04.png'),
        i1s: 0.30,
        i2s: 0.35 * 1.25,
        top1: 0,
        left1: 0,
        top2: 0,
        left2: 0,
        active: false,
        [Text.ENG]: {
          name: 'Han',
          subtitle: 'Aged 10, Female, Cancer',
          desc: `I wish to have a huge teddy bear`
        },
        [Text.CHI]: {
          name: '嫻',
          subtitle: '10歲, 女, 癌症',
          desc: `我想擁有一隻巨形Bear bear熊`
        }
      },
      {
        id: 5,
        i1: require('./Items3/05.png'),
        i2: require('./Items3/05.png'),
        i1s: 0.30,
        i2s: 0.35 * 1.25,
        top1: 0,
        left1: 0,
        top2: 0,
        left2: 0,
        active: false,
        [Text.ENG]: {
          name: `Ching`,
          subtitle: `Aged 9, Female, Cancer`,
          desc: `I wish to have my own princess bed`
        },
        [Text.CHI]: {
          name: `晴`,
          subtitle: `9歲, 女, 癌症`,
          desc: `我想擁有一間自己設計的公主床`
        }
      },
      {
        id: 16,
        i1: require('./Items3/16.png'),
        i2: require('./Items3/16.png'),
        i1s: 0.30,
        i2s: 0.35 * 1.25,
        top1: 0,
        left1: 0,
        top2: 0,
        left2: 0,
        active: false,
        [Text.ENG]: {
          name: `Man`,
          subtitle: `Aged 9, Female, Cancer`,
          desc: `I wish to meet my sister who is currently studying abroad in England`
        },
        [Text.CHI]: {
          name: `閔`,
          subtitle: `9歲, 女, 癌症`,
          desc: `我想見在英國留學中的家姐`
        }
      },
      {
        id: 1,
        i1: require('./Items3/01.png'),
        i2: require('./Items3/01.png'),
        i1s: 0.30,
        i2s: 0.35 * 1.25,
        top1: 0,
        left1: 0,
        top2: 0,
        left2: 0,
        active: true,
        [Text.ENG]: {
          name: 'Ho',
          subtitle: 'Aged 17, Male, Cancer',
          desc: `I wish to have a professional camera for night time shooting.`
        },
        [Text.CHI]: {
          name: `豪`,
          subtitle: `17歲 男, 癌症`,
          desc: `我想擁有一部專業的相機\n進行晚間拍攝`
        }
      },
      {
        id: 11,
        i1: require('./Items3/11.png'),
        i2: require('./Items3/11.png'),
        i1s: 0.30,
        i2s: 0.35 * 1.25,
        top1: 0,
        left1: 0,
        top2: 0,
        left2: 0,
        active: false,
        [Text.ENG]: {
          name: `Fung`,
          subtitle: `Aged 9, Male, Cancer`,
          desc: `I wish to experience the joy of WorldCup.`
        },
        [Text.CHI]: {
          name: `豐`,
          subtitle: `9歲, 男, 癌症`,
          desc: `我想親身感受世界杯的氣氛`
        }
      },
      {
        id: 10,
        i1: require('./Items3/10.png'),
        i2: require('./Items3/10.png'),
        i1s: 0.30,
        i2s: 0.35 * 1.25,
        top1: 0,
        left1: 0,
        top2: 0,
        left2: 0,
        active: false,
        [Text.ENG]: {
          name: `Him`,
          subtitle: `Aged 8, Male, Cancer`,
          desc: `I wish to take a JR Train ride in Japan`
        },
        [Text.CHI]: {
          name: `謙`,
          subtitle: `8歲, 男, 癌症`,
          desc: `我想坐日本JR火車`
        }
      },
      {
        id: 3,
        i1: require('./Items3/03.png'),
        i2: require('./Items3/03.png'),
        i1s: 0.30,
        i2s: 0.35 * 1.25,
        top1: 0,
        left1: 0,
        top2: 0,
        left2: 0,
        active: false,
        [Text.ENG]: {
          name: 'Sze Wan',
          subtitle: 'Aged 10, Female, Cancer',
          desc: `I wish to have my own Piano.`
        },
        [Text.CHI]: {
          name: `詩韻`,
          subtitle: `10歲 女, 癌症`,
          desc: `我想擁有一部鋼琴`
        }
      },
      {
        id: 20,
        i1: require('./Items3/20.png'),
        i2: require('./Items3/20.png'),
        i1s: 0.30,
        i2s: 0.35 * 1.25,
        top1: 0,
        left1: 0,
        top2: 0,
        left2: 0,
        active: false,
        [Text.ENG]: {
          name: `Hei`,
          subtitle: `Aged 13, Female, Cancer`,
          desc: `I wish to learn how to play a guitar.`
        },
        [Text.CHI]: {
          name: `僖`,
          subtitle: `13歲, 女, 癌症`,
          desc: `我想學結他`
        }
      },
      // {
      //   id: 13,
      //   i1: require('./Items3/13.png'),
      //   i2: require('./Items3/13.png'),
      //   i1s: 0.30,
      //   i2s: 0.35 * 1.25,
      //   top1: 0,
      //   left1: 0,
      //   top2: 0,
      //   left2: 0,
      //   active: false,
      //   [Text.ENG]: {
      //     name: `Hei`,
      //     subtitle: `Aged 7, Male, Cancer`,
      //     desc: `I wish to meet The Fat Controller in Thomas and Friends`
      //   },
      //   [Text.CHI]: {
      //     name: `熙`,
      //     subtitle: `7歲, 男, 癌症`,
      //     desc: `我想見湯瑪士小火車裡的「肥控制員」`
      //   }
      // },
      {
        id: 7,
        i1: require('./Items3/07.png'),
        i2: require('./Items3/07.png'),
        i1s: 0.30,
        i2s: 0.35 * 1.25,
        top1: 0,
        left1: 0,
        top2: 0,
        left2: 0,
        active: false,
        [Text.ENG]: {
          name: 'Yuen',
          subtitle: 'Aged 5, Male, Cancer',
          desc: `I wish to visit Legoland in Japan.`
        },
        [Text.CHI]: {
          name: `源`,
          subtitle: `5歲, 男, 癌症`,
          desc: `我想去日本的樂高主題樂園`
        }
      },
      {
        id: 8,
        i1: require('./Items3/08.png'),
        i2: require('./Items3/08.png'),
        i1s: 0.30,
        i2s: 0.35 * 1.25,
        top1: 0,
        left1: 0,
        top2: 0,
        left2: 0,
        active: false,
        [Text.ENG]: {
          name: 'Yau',
          subtitle: 'Aged 9 Female, Cancer',
          desc: `I wish to visit Australia to see koala.`
        },
        [Text.CHI]: {
          name: `悠`,
          subtitle: `9歲, 女, 癌症`,
          desc: `我想去澳洲親親樹熊`
        }
      },
      {
        id: 6,
        i1: require('./Items3/06.png'),
        i2: require('./Items3/06.png'),
        i1s: 0.30,
        i2s: 0.35 * 1.25,
        top1: 0,
        left1: 0,
        top2: 0,
        left2: 0,
        active: false,
        [Text.ENG]: {
          name: `Yi`,
          subtitle: `Aged 9, Female, Cancer`,
          desc: `I wish to organize a huge birthday party.`
        },
        [Text.CHI]: {
          name: `怡`,
          subtitle: `9歲, 女, 癌症`,
          desc: `我想擁有一個盛大的生日派對`
        }
      },
      {
        id: 9,
        i1: require('./Items3/09.png'),
        i2: require('./Items3/09.png'),
        i1s: 0.30,
        i2s: 0.35 * 1.25,
        top1: 0,
        left1: 0,
        top2: 0,
        left2: 0,
        active: false,
        [Text.ENG]: {
          name: `Man`,
          subtitle: `Aged 10, Male, Cancer`,
          desc: `I wish to visit where Doraemon and Noby were born.`
        },
        [Text.CHI]: {
          name: `文`,
          subtitle: `10歲, 男, 癌症`,
          desc: `我想去多啦A夢及大雄的發源地`
        }
      },
      {
        id: 18,
        i1: require('./Items3/18.png'),
        i2: require('./Items3/18.png'),
        i1s: 0.30,
        i2s: 0.35 * 1.25,
        top1: 0,
        left1: 0,
        top2: 0,
        left2: 0,
        active: false,
        [Text.ENG]: {
          name: `Sze`,
          subtitle: `Aged 15, Female, Cancer`,
          desc: `I wish to watch Mnet Asian Music Awards Live`
        },
        [Text.CHI]: {
          name: `思`,
          subtitle: `15歲, 女, 癌症`,
          desc: `我想觀看韓國亞洲音樂
大獎頒獎禮`
        }
      },
      {
        id: 2,
        i1: require('./Items3/02.png'),
        i2: require('./Items3/02.png'),
        i1s: 0.30,
        i2s: 0.35 * 1.25,
        top1: 0,
        left1: 0,
        top2: 0,
        left2: 0,
        active: false,
        [Text.ENG]: {
          name: `Him`,
          subtitle: `Aged 14, Male, Cancer`,
          desc: `I wish to have a gaming computer.`
        },
        [Text.CHI]: {
          name: `謙`,
          subtitle: `14歲, 男, 癌症`,
          desc: `我想擁有一部電競電腦`
        }
      },
      {
        id: 17,
        i1: require('./Items3/17.png'),
        i2: require('./Items3/17.png'),
        i1s: 0.30,
        i2s: 0.35 * 1.25,
        top1: 0,
        left1: 0,
        top2: 0,
        left2: 0,
        active: false,
        [Text.ENG]: {
          name: `Lam Lam`,
          subtitle: `Aged 4, Female, Cancer`,
          desc: `I wish to be a handsome super heroine.`
        },
        [Text.CHI]: {
          name: `霖霖`,
          subtitle: `4歲, 女, 癌症`,
          desc: `我想成為一個帥氣的超級女英雄`
        }
      },
      {
        id: 14,
        i1: require('./Items3/14.png'),
        i2: require('./Items3/14.png'),
        i1s: 0.30,
        i2s: 0.35 * 1.25,
        top1: 0,
        left1: 0,
        top2: 0,
        left2: 0,
        active: false,
        [Text.ENG]: {
          name: `Ying`,
          subtitle: `Aged 6, Female, Cancer`,
          desc: `I wish to meet Pegga Pig`
        },
        [Text.CHI]: {
          name: `瑩`,
          subtitle: `Aged 6, 女, 癌症`,
          desc: `我想見Peppa Pig`
        }
      },
      {
        id: 15,
        i1: require('./Items3/15.png'),
        i2: require('./Items3/15.png'),
        i1s: 0.30,
        i2s: 0.35 * 1.25,
        top1: 0,
        left1: 0,
        top2: 0,
        left2: 0,
        active: false,
        [Text.ENG]: {
          name: `To`,
          subtitle: `Age8, Male, Cancer`,
          desc: `I wish to meet my favorite Super Hero`
        },
        [Text.CHI]: {
          name: `濤`,
          subtitle: `8歲, 男, 癌症`,
          desc: `我想見最愛的超級英雄`
        }
      },
      {
        id: 19,
        i1: require('./Items3/19.png'),
        i2: require('./Items3/19.png'),
        i1s: 0.30,
        i2s: 0.35 * 1.25,
        top1: 0,
        left1: 0,
        top2: 0,
        left2: 0,
        active: false,
        [Text.ENG]: {
          name: `Yi`,
          subtitle: `Aged 17, Female, Cancer`,
          desc: `I wish to learn how to create a comic book`
        },
        [Text.CHI]: {
          name: `怡`,
          subtitle: `17歲, 女, 癌症`,
          desc: `我想學習漫畫創作`
        }
      },
      {
        id: 12,
        i1: require('./Items3/12.png'),
        i2: require('./Items3/12.png'),
        i1s: 0.30,
        i2s: 0.35 * 1.25,
        top1: 0,
        left1: 0,
        top2: 0,
        left2: 0,
        active: false,
        [Text.ENG]: {
          name: `Yan`,
          subtitle: `Aged 15, Male, \nDuchenne muscular dystrophy (DMD)`,
          desc: `I wish to go on a trip with my mom on my wheelchair`
        },
        [Text.CHI]: {
          name: `仁`,
          subtitle: `15歲 男, 杜興氏肌肉營養不良症`,
          desc: `我想帶著輪椅和媽媽一起旅行`
        }
      }
    ]

    let photoSet = [
      {
        id: '1',
        photo: require('./WishPhotos/1.jpg'),
        [Text.ENG]: {
          title: '',
          desc: '',
          wish: ''
        },
        [Text.CHI]: {
          title: '晴',
          desc: '9歲，女，癌症',
          wish: '很高興可以擁有自己的公主床'
        }
      },
      {
        id: '2',
        photo: require('./WishPhotos/2.jpg'),
        [Text.ENG]: {
          title: '',
          desc: '',
          wish: ''
        },
        [Text.CHI]: {
          title: '悠',
          desc: '9歲，女，癌症',
          wish: '很高興可以到澳洲親親樹熊'
        }
      },
      {
        id: '3',
        photo: require('./WishPhotos/3.jpg'),
        [Text.ENG]: {
          title: '',
          desc: '',
          wish: ''
        },
        [Text.CHI]: {
          title: '怡',
          desc: '9歲，女，癌症',
          wish: '很高興可以擁有一個盛大的生日派對'
        }
      },
      {
        id: '4',
        photo: require('./WishPhotos/4.jpg'),
        [Text.ENG]: {
          title: '',
          desc: '',
          wish: ''
        },
        [Text.CHI]: {
          title: '閔',
          desc: '9歲，女，癌症',
          wish: '很高興可以見英國留學中的家姐'
        }
      }
    ]

    return {
      photoSet,
      Text,
      SC: Text.state,
      T: Text.T,
      ENG: Text.ENG,
      CHI: Text.CHI,
      iK: kidsItems.findIndex(e => e.active === true),
      fsMenu: false,
      clean () {},
      kidsItems
    }
  },
  mounted () {
    ScrollMonitor.setPercentage(0)
    this.setupScroll()
    window.addEventListener('resize', () => {
      this.setupScroll()
    })
  },
  methods: {
    setupScroll () {
      this.clean()
      var scroller = this.$refs['scroller']
      if (!scroller) {
        return
      }
      var content = this.$refs['content']
      var scrollerHeight = scroller.getBoundingClientRect().height
      var ccontentHeight = content.getBoundingClientRect().height
      var onScroll = () => {
        this.scrollPos = scroller.scrollTop

        ScrollMonitor.state.percentage = 0.2 * (scroller.scrollTop) / (ccontentHeight - scrollerHeight)
        // console.log(ScrollMonitor.state.percentage)
      }
      scroller.addEventListener('scroll', onScroll, false)

      this.clean = () => {
        if (scroller) {
          scroller.removeEventListener('scroll', onScroll)
        }
      }
    }
  },
  beforeDestroy () {
    this.clean()
  }
}
</script>

<style scoped>
.kids-wishes-layout{
  color: white;
}
.full-menu{
  position: absolute;
  top: 0px;
  left: 0px;
}
.float-menu{
  position: absolute;
  top: 0px;
  left: 0px;
}
.layers{
  width: 100%;
  height: 100%;
  position: relative;
  overflow:hidden;
}

.scroller{
  position: absolute;
  top: 0px;
  left: 0px;

  width: 100%;
  height: 100%;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  color: white;
}
.top-taller{
  height: 120px;
}
.taller{
  height: 75vh;
}

.bottom-taller{
  height: 50px;
}

.make-a-wish{
  margin-top: 25px;
  text-transform: uppercase;
  /* Make-A-Wish: */
  border: 0 solid #573A09;
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 12px;
  color: #C6B9A3;
  letter-spacing: 1.5px;
  text-align: center;
  line-height: 20px;
}

@media screen and (min-width: 25px) {

}

.wish-children{
  margin-top: 15px;
  /* Wish Children: */
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 28px;
  color: #F5EEDE;
  letter-spacing: 1px;
  text-align: center;
  line-height: 34px;
}

.maw-desc-row{
  margin-top: 15px;
  display: flex;
  justify-content: center;
}
.maw-desc{
  max-width: 285px;
  /* For 20 years, with t: */
  border: 0 solid #CEBC9E;
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 14px;
  color: #FFFFFF;
  letter-spacing: 1px;
  line-height: 21px;
}

.ribbon-row{
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.cards-row{
  display: flex;
  justify-content: center;
  margin-top: 30px;
}

.link-row{
  margin-top: 5px;
  text-align: center;
}
.maw-link,
.maw-link:active,
.maw-link:hover,
.maw-link:visited{
  text-decoration: none;
  border-bottom: #C6B9A3 solid 1px;
  text-transform: uppercase;
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 12px;
  color: #C6B9A3;
  letter-spacing: 1.5px;
  text-align: center;
  line-height: 20px;
}

@media screen and (min-width: 767.77px) {
/* @media screen and (min-width: 1439px) { */
  .maw-desc{
    max-width: 593px;
  }
  .single-row.wish-children{
    font-size: 30px;
  }
  .single-row.make-a-wish{
    font-size: 14px;
  }
  .cards-row > * {
    transform: scale(1.1);
  }
}

/*-------------------------*/

.top-taller{
  height: 115px;
}
.make-a-wish{
  margin-top: 0px;
}

.gallery{
  margin: 0px auto;
  margin-top: 38px;
  width: 100%;
  max-width: 250px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.ps-title{
  margin-top: 20px;
  /* 晴: */
  /* border: 1px solid #FFFFFF; */
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 18px;
  color: #CEBC9E;
  letter-spacing: 1.5px;
  text-align: center;
  line-height: 20px;
}

.ps-desc{
  margin-top: 13px;
  /* 9歲，女，癌症: */
  /* border: 1px solid #FFFFFF; */
  font-family: PingFangTC-Light;
  font-size: 13px;
  color: #FFFFFF;
  letter-spacing: 1.08px;
  text-align: center;
  line-height: 20px;
}

.ps-wish{
  margin-top: 22px;
  /* 很高興可以擁有自己的公主床: */
  /* border: 1px solid #FFFFFF; */
  font-family: PingFangTC-Light;
  font-size: 16px;
  color: #CEBC9E;
  letter-spacing: 1.33px;
  text-align: center;
  line-height: 20px;
}


.ps-photo img{
  width: 100%;
}

.ps-photo{
  width: 250px;
}

.photo-set{
  margin-top: 45px;
}
.photo-set:nth-child(1){
  margin-top: 0px;
}
@media screen and (min-width: 767px) {
  .photo-set:nth-child(2){
    margin-top: 0px;
  }
  .ps-photo {
    width: 500px;
  }
  .photo-set{
    width: 500px;
  }
  .gallery{
    margin: 0px auto;
    margin-top: 67px;
    width: 100%;
    max-width: 1058px;
    display: flex;
    justify-content: space-between;
  }

}

</style>



// WEBPACK FOOTER //
// src/components/Pages/KidsWishes/KidsWishes.vue